import exportFromJSON from "export-from-json";

// copied manually from from "export-from-json/dist/types/exportFromJSON";
// to not have to rely on old tsconfig moduleResolution=node
export type ExportType = "txt" | "json" | "csv" | "xls" | "xml" | "css" | "html";
export interface IOption<R = void> {
  data: object | string;
  fileName?: string;
  extension?: string;
  fileNameFormatter?: (name: string) => string;
  fields?: string[] | Record<string, string>;
  exportType?: ExportType;
  replacer?: ((key: string, value: any) => any) | Array<number | string> | null;
  space?: string | number;
  processor?: (content: string, type: ExportType, fileName: string) => R;
  withBOM?: boolean;
  beforeTableEncode?: (
    tableRow: Array<{
      fieldName: string;
      fieldValues: string[];
    }>
  ) => Array<{
    fieldName: string;
    fieldValues: string[];
  }>;
  delimiter?: "," | ";";
}

export const exportJson = ({ data, fileName }: IOption<void>) => {
  return exportFromJSON({ data, fileName, exportType: "json" });
};
